var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKazakhstan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_34751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.783 12.1305H5.21777C5.21777 13.067 6.03345 13.8261 6.96987 13.8261H6.91343C6.91343 14.7627 7.67257 15.5218 8.60909 15.5218C8.60909 16.4583 9.36823 17.2175 10.3047 17.2175H13.6961C14.6326 17.2175 15.3917 16.4583 15.3917 15.5218C16.3282 15.5218 17.0874 14.7627 17.0874 13.8261H17.0309C17.9673 13.8261 18.783 13.067 18.783 12.1305Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.696 9.91309C16.696 12.5064 14.5937 14.6087 12.0003 14.6087C9.40698 14.6087 7.30469 12.5064 7.30469 9.91309",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5864 9.91299L14.1208 10.6024L14.9012 12.0218L13.3098 11.7173L13.1082 13.3249L11.9997 12.1425L10.8912 13.3249L10.6896 11.7173L9.09821 12.0217L9.87859 10.6023L8.41309 9.91299L9.87863 9.22365L9.09821 7.80432L10.6896 8.10872L10.8913 6.5011L11.9997 7.68352L13.1082 6.5011L13.3098 8.10872L14.9013 7.80432L14.1209 9.22369L15.5864 9.91299Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_34751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/4e4ae092.svg";
export { SvgKazakhstan as ReactComponent };